export const utilesMixin = {
    methods: {
        formatoNumero(num) {
            if(num != undefined){

                var numero = num.toString().trim();

                var nuevoNumero = "";

                var resultado = "";

                if (numero[0] == "-") {
                    nuevoNumero = numero.replace(/\./g, '').substring(1);
                } else {
                    nuevoNumero = numero.replace(/\./g, '');
                }

                if (numero.indexOf(",") >= 0)
                    nuevoNumero = nuevoNumero.substring(0, nuevoNumero.indexOf(","));

                for (var j, i = nuevoNumero.length - 1, j = 0; i >= 0; i--, j++)
                    resultado = nuevoNumero.charAt(i) + ((j > 0) && (j % 3 == 0) ? "." : "") + resultado;

                if (numero.indexOf(",") >= 0)
                    resultado += numero.substring(numero.indexOf(","));

                if (numero[0] == "-") {
                    return "-" + resultado;
                } else {
                    return resultado;
                }
            }
        },
        formato_rut(rut) {

            if(rut != undefined){
                var sRut1 = rut.toString();
                sRut1 = sRut1.replace('-', '');// se elimina el guion
                sRut1 = sRut1.replace('.', '');// se elimina el primer punto
                sRut1 = sRut1.replace('.', '');// se elimina el segundo punto
                sRut1 = sRut1.replace(/k$/, "K");
                //contador de para saber cuando insertar el . o la -
                var nPos = 0;
                //Guarda el rut invertido con los puntos y el gui&oacute;n agregado
                var sInvertido = "";
                //Guarda el resultado final del rut como debe ser
                var sRut = "";
                for (var i = sRut1.length - 1; i >= 0; i--) {
                    sInvertido += sRut1.charAt(i);
                    if (i == sRut1.length - 1)
                        sInvertido += "-";
                    else if (nPos == 3) {
                        sInvertido += ".";
                        nPos = 0;
                    }
                    nPos++;
                }
                for (var j = sInvertido.length - 1; j >= 0; j--) {
                    if (sInvertido.charAt(sInvertido.length - 1) != ".")
                        sRut += sInvertido.charAt(j);
                    else if (j != sInvertido.length - 1)
                        sRut += sInvertido.charAt(j);
                }
                //Pasamos al campo el valor formateado
                return sRut.toUpperCase();
            }
        },
        formatofecha(fechaEntrada, separador){
            var fecha = new Date(fechaEntrada);

            var dia = fecha.getDate();
            var mes = fecha.getMonth() + 1;

            if(dia < 10)
            {
                dia = "0" + dia.toString();
            }
            
            if(mes < 10)
            {
                mes = "0" + mes.toString();
            }

            var año = fecha.getFullYear();

            fecha = dia + separador + mes + separador + año;

            return fecha;

        },
        convierteFecha(fechaEntrada){
            if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
                var fecha = new Date(fechaEntrada);

                var dia = ("0" + fecha.getUTCDate()).slice(-2);
                var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
                var año = fecha.getUTCFullYear();


                fecha = dia + '-' + mes + '-' + año;

                return fecha;
            }
            else{
                return fechaEntrada;
            }
        },
        convierteFechaMoment(fechaEntrada){
            var fecha = new Date(fechaEntrada);

            var dia = fecha.getDate();
            var mes = fecha.getMonth() + 1;
            var año = fecha.getFullYear();

            fecha = año + '-' + mes + '-' + dia;

            return fecha;
        },
        replaceAll(text, busca, reemplaza) {
                if(!this.isNullorEmpty(text)){
                    while (text.toString().indexOf(busca) != -1) {
                    text = text.toString().replace(busca, reemplaza);
                }
            }

            return text;
        },
        isNullorEmpty(text){
            if(text == undefined || text == null || text == ""){
                return true;
            }else{
                return false;
            }
        },
        prepararReferencia1(rut){
            rut = this.replaceAll(rut, ".", "");
            rut = this.replaceAll(rut, "-", "");
            rut = rut.substring(0, rut.length - 1);
            return rut;
        },   
        prepararRutNumerico(rut){
            rut = this.replaceAll(rut, ".", "");
            rut = this.replaceAll(rut, "-", "");
            return rut;
        },     
        configurarFecha(fecha){
            var año = fecha.substring(0, 4);
            var mes = fecha.substring(6, 7);
            var dia = fecha.substring(9, 10);

            fecha = dia + "-" + mes + "-" + año;
            return fecha;
        },
        configurarFechaLat(fecha){
            if ((fecha==undefined) || (fecha.length<=0))
               return fecha;

            var año = fecha.substring(6, 10);
            var mes = fecha.substring(3, 5);
            var dia = fecha.substring(0, 2);

            fecha = dia + "/" + mes + "/" + año;
            return fecha;
        },
        generaCartola(tabla){

            var uri = 'data:application/vnd.ms-excel;base64,'
                , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>' + tabla + '</table></body></html>'
                , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
                , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
                , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }

                var table = 'tbCartola';
                var name = 'descarga';

            //if (!table.nodeType) table = document.getElementById(table)
            var ctx = { worksheet: name || 'Worksheet', table: tabla }

            window.open(uri + base64(format(template, ctx)));
            
        },
        generaExcel(nombre, tabla){

            var uri = 'data:application/vnd.ms-excel;base64,'
                , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>' + tabla + '</table></body></html>'
                , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
                , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
                , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }

                var table = 'tbTabla';
                var name = nombre;

            var ctx = { worksheet: 'Worksheet', table: tabla }
            
            window.open(uri + base64(format(template, ctx)));
            
        },
        generaExcelV2(nombre, tabla){

            var uri = 'data:application/vnd.ms-excel;base64,'
                , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><style>br {mso-data-placement: same-cell;}</style></head><body><table>' + tabla + '</table></body></html>'
                , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
                , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
                , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }

                var table = 'tbTabla';
                var name = nombre;

            var ctx = { worksheet: 'Worksheet', table: tabla }
            
            return uri + base64(format(template, ctx));
            
        }        

    }
}